module.exports = __webpack_public_path__ + "static/media/image_3.d38061fa.svg";